function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrButlerLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 481 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "hr_butler_logo_Blue-White"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.994,92.285l2.737,-0l0,-6.442l5.593,0l-0,-2.289l-5.593,0l0,-4.365l6.584,-0l-0,-2.289l-9.321,-0l-0,15.385Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.225,92.568c1.581,-0 2.69,-0.778 3.705,-1.982l0.071,-0l0.188,1.699l2.218,0l0,-11.586l-2.713,-0l-0,7.928c-0.873,1.133 -1.534,1.605 -2.549,1.605c-1.25,0 -1.793,-0.708 -1.793,-2.596l-0,-6.914l-2.714,0l0,7.268c0,2.926 1.086,4.602 3.563,4.602l0.024,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.653,92.568c0.637,-0 1.086,-0.094 1.416,-0.212l-0.33,-2.029c-0.189,0.046 -0.283,0.046 -0.401,0.046c-0.284,0 -0.567,-0.235 -0.567,-0.896l0,-13.828l-2.714,0l0,13.686c0,2.006 0.708,3.233 2.62,3.233l-0.024,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.081,92.568c0.637,-0 1.085,-0.094 1.415,-0.212l-0.33,-2.029c-0.189,0.047 -0.283,0.047 -0.401,0.047c-0.284,-0 -0.567,-0.236 -0.567,-0.897l0,-13.828l-2.713,0l-0,13.686c-0,2.006 0.708,3.233 2.619,3.233l-0.023,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.586,
    y: 85.347,
    width: 5.592,
    height: 1.982,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8,92.568c3.445,0 5.522,-2.076 5.522,-4.578c-0,-2.218 -1.275,-3.374 -3.092,-4.129l-2.076,-0.873c-1.274,-0.52 -2.43,-0.968 -2.43,-2.171c-0,-1.109 0.943,-1.794 2.406,-1.794c1.322,0 2.36,0.472 3.328,1.298l1.392,-1.722c-1.204,-1.204 -2.95,-1.935 -4.743,-1.935c-2.997,-0 -5.168,1.887 -5.168,4.342c0,2.241 1.581,3.445 3.091,4.058l2.1,0.897c1.393,0.59 2.384,0.991 2.384,2.242c-0,1.203 -0.944,1.982 -2.667,1.982c-1.416,0 -2.879,-0.708 -3.964,-1.746l-1.581,1.864c1.463,1.439 3.469,2.242 5.545,2.242l-0.047,0.023Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.599,92.568c1.463,0 2.855,-0.495 3.941,-1.227l-0.921,-1.675c-0.849,0.519 -1.698,0.826 -2.69,0.826c-1.864,-0 -3.185,-1.157 -3.398,-3.21l7.339,0c0.047,-0.283 0.094,-0.802 0.094,-1.321c0,-3.233 -1.651,-5.498 -4.766,-5.498c-2.714,-0 -5.31,2.312 -5.31,6.064c0,3.823 2.502,6.065 5.688,6.065l0.023,-0.024Zm-3.091,-7.15c0.236,-1.84 1.416,-2.832 2.761,-2.832c1.581,0 2.36,1.086 2.36,2.856l-5.121,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.112,92.285l2.713,0l0,-7.056c0.685,-1.746 1.794,-2.359 2.714,-2.359c0.472,-0 0.755,0.071 1.156,0.165l0.472,-2.36c-0.33,-0.141 -0.684,-0.212 -1.274,-0.212c-1.227,-0 -2.454,0.826 -3.28,2.336l-0.071,-0l-0.189,-2.053l-2.218,-0l-0.023,11.539Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.389,92.285l3.138,0l3.917,-11.586l-2.619,-0l-1.84,5.993c-0.307,1.133 -0.638,2.313 -0.944,3.469l-0.094,0c-0.307,-1.156 -0.638,-2.336 -0.945,-3.469l-1.84,-5.993l-2.737,-0l3.964,11.586Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.079,92.285l2.714,0l0,-11.586l-2.714,-0l0,11.586Zm1.369,-13.616c0.944,0 1.652,-0.636 1.652,-1.533c-0,-0.897 -0.708,-1.51 -1.652,-1.51c-0.944,-0 -1.652,0.613 -1.652,1.51c0,0.897 0.708,1.533 1.652,1.533Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.332,92.568c1.322,0 2.69,-0.448 3.776,-1.392l-1.086,-1.793c-0.66,0.542 -1.486,0.967 -2.383,0.967c-1.793,0 -3.067,-1.51 -3.067,-3.822c-0,-2.313 1.274,-3.847 3.138,-3.847c0.708,-0 1.274,0.307 1.888,0.826l1.321,-1.746c-0.826,-0.732 -1.888,-1.298 -3.351,-1.298c-3.067,0 -5.781,2.218 -5.781,6.065c-0,3.822 2.407,6.04 5.569,6.04l-0.024,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.677,92.568c1.463,0 2.855,-0.495 3.94,-1.227l-0.92,-1.675c-0.849,0.519 -1.699,0.826 -2.69,0.826c-1.864,-0 -3.185,-1.157 -3.398,-3.21l7.339,0c0.047,-0.283 0.094,-0.802 0.094,-1.321c0,-3.233 -1.651,-5.498 -4.767,-5.498c-2.713,0 -5.309,2.312 -5.309,6.065c0,3.822 2.502,6.064 5.687,6.064l0.024,-0.024Zm-3.091,-7.15c0.236,-1.84 1.415,-2.831 2.76,-2.831c1.582,-0 2.36,1.085 2.36,2.855l-5.12,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.664,92.285l2.737,0l-0,-5.663l2.218,-0c3.304,-0 5.852,-1.558 5.852,-4.979c0,-3.563 -2.524,-4.743 -5.946,-4.743l-4.861,-0l-0,15.385Zm2.737,-7.834l-0,-5.38l1.888,-0c2.289,-0 3.469,0.637 3.469,2.548c-0,1.888 -1.086,2.785 -3.375,2.785l-1.982,0.047Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.273,92.568c1.369,0 2.548,-0.66 3.587,-1.534l0.071,0l0.188,1.275l2.219,-0l-0,-6.844c-0,-3.209 -1.416,-4.978 -4.295,-4.978c-1.841,-0 -3.469,0.707 -4.743,1.51l0.991,1.793c1.015,-0.613 2.1,-1.132 3.233,-1.132c1.557,-0 2.053,1.038 2.076,2.265c-4.743,0.495 -6.796,1.77 -6.796,4.247c0,2.006 1.393,3.375 3.422,3.375l0.047,0.023Zm0.802,-2.147c-0.967,0 -1.651,-0.448 -1.651,-1.463c-0,-1.156 1.038,-1.959 4.176,-2.336l0,2.595c-0.849,0.779 -1.557,1.228 -2.501,1.228l-0.024,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.724,97.028c2.524,0 3.728,-1.605 4.672,-4.2l4.176,-12.105l-2.619,-0l-1.723,5.663c-0.282,1.038 -0.566,2.171 -0.849,3.233l-0.094,-0c-0.331,-1.086 -0.661,-2.219 -0.992,-3.233l-1.982,-5.663l-2.737,-0l4.554,11.444l-0.212,0.708c-0.377,1.156 -1.085,1.982 -2.289,1.982c-0.259,0 -0.59,-0.094 -0.802,-0.141l-0.496,2.1c0.425,0.141 0.873,0.236 1.487,0.236l-0.094,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.255,92.285l2.713,0l0,-7.056c0.684,-1.746 1.794,-2.359 2.714,-2.359c0.472,0 0.755,0.071 1.156,0.165l0.472,-2.359c-0.33,-0.142 -0.684,-0.213 -1.274,-0.213c-1.227,0 -2.454,0.826 -3.28,2.336l-0.071,0l-0.189,-2.053l-2.218,0l-0.023,11.539Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.098,92.568c2.879,0 5.498,-2.218 5.498,-6.04c0,-3.847 -2.619,-6.065 -5.498,-6.065c-2.879,0 -5.498,2.218 -5.498,6.065c0,3.822 2.619,6.04 5.498,6.04Zm0,-2.218c-1.699,0 -2.714,-1.51 -2.714,-3.822c0,-2.313 1.015,-3.847 2.714,-3.847c1.699,0 2.714,1.534 2.714,3.847c-0,2.312 -1.015,3.822 -2.714,3.822Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.29,92.568c0.637,0 1.085,-0.094 1.415,-0.212l-0.33,-2.029c-0.188,0.047 -0.283,0.047 -0.401,0.047c-0.283,-0 -0.566,-0.236 -0.566,-0.897l-0,-13.828l-2.714,0l-0,13.686c-0,2.006 0.708,3.233 2.619,3.233l-0.023,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.717,92.568c0.637,0 1.086,-0.094 1.416,-0.212l-0.33,-2.029c-0.189,0.047 -0.284,0.047 -0.402,0.047c-0.283,-0 -0.566,-0.236 -0.566,-0.897l-0,-13.828l-2.713,0l-0,13.686c-0,2.006 0.707,3.233 2.619,3.233l-0.024,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,96.58c2.313,-0.803 3.634,-2.572 3.634,-4.885c-0,-1.746 -0.732,-2.784 -2.006,-2.784c-0.991,-0 -1.793,0.637 -1.793,1.652c-0,1.061 0.825,1.651 1.746,1.651l0.212,0c0,1.227 -0.849,2.266 -2.359,2.832l0.566,1.534Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.248,92.285l2.737,0l-0,-6.843l6.23,-0l-0,6.843l2.737,0l-0,-15.432l-2.737,-0l-0,6.182l-6.23,0l-0,-6.182l-2.737,-0l-0,15.432Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.844,84.073l0,-5.002l2.171,-0c2.1,-0 3.233,0.613 3.233,2.383c-0,1.746 -1.133,2.619 -3.233,2.619l-2.171,0Zm5.663,8.212l3.068,0l-3.681,-6.418c1.841,-0.638 3.067,-2.053 3.067,-4.389c0,-3.445 -2.454,-4.578 -5.663,-4.578l-5.191,0l-0,15.432l2.737,0l0,-6.017l2.336,0l3.327,5.97Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.654,96.58c2.312,-0.803 3.634,-2.572 3.634,-4.885c-0,-1.746 -0.732,-2.784 -2.006,-2.784c-0.991,-0 -1.793,0.637 -1.793,1.652c-0,1.061 0.825,1.651 1.746,1.651l0.212,0c0,1.228 -0.849,2.266 -2.359,2.832l0.566,1.534Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.755,92.568c1.865,0 3.375,-0.637 4.602,-1.651c1.274,0.802 2.548,1.345 3.728,1.604l0.661,-2.218c-0.802,-0.165 -1.747,-0.59 -2.737,-1.18c1.203,-1.605 2.053,-3.398 2.619,-5.333l-2.478,0c-0.425,1.581 -1.085,2.95 -1.935,4.082c-1.298,-1.014 -2.548,-2.241 -3.492,-3.515c1.675,-1.156 3.351,-2.431 3.351,-4.46c-0,-1.935 -1.298,-3.257 -3.399,-3.257c-2.359,0 -3.869,1.723 -3.869,3.847c-0,1.038 0.354,2.194 0.967,3.374c-1.533,1.015 -2.902,2.265 -2.902,4.365c-0,2.407 1.84,4.319 4.908,4.319l-0.024,0.023Zm2.809,-3.044c-0.779,0.567 -1.605,0.897 -2.431,0.897c-1.51,0 -2.643,-0.944 -2.643,-2.36c0,-0.92 0.614,-1.675 1.463,-2.383c0.991,1.392 2.265,2.737 3.634,3.87l-0.023,-0.024Zm-2.856,-6.866c-0.377,-0.779 -0.59,-1.534 -0.59,-2.218c0,-1.181 0.661,-1.983 1.628,-1.983c0.874,0 1.228,0.614 1.228,1.416c-0,1.18 -1.015,1.959 -2.266,2.737l0,0.048Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.919,92.285l5.333,0c3.397,0 5.922,-1.439 5.922,-4.507c0,-2.076 -1.25,-3.256 -2.949,-3.634l0,-0.094c1.345,-0.472 2.124,-1.888 2.124,-3.327c-0,-2.832 -2.313,-3.799 -5.475,-3.799l-4.931,-0l-0.024,15.361Zm2.76,-8.99l0,-4.224l2.006,0c1.982,0 2.974,0.566 2.974,2.053c-0,1.321 -0.897,2.147 -3.045,2.147l-1.935,0.024Zm0,6.89l0,-4.861l2.313,0c2.289,0 3.516,0.708 3.516,2.312c0,1.723 -1.251,2.525 -3.516,2.525l-2.313,0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.44,92.568c1.463,0 2.855,-0.495 3.94,-1.227l-0.92,-1.675c-0.849,0.519 -1.699,0.826 -2.69,0.826c-1.864,-0 -3.186,-1.156 -3.398,-3.209l7.339,-0c0.047,-0.283 0.094,-0.803 0.094,-1.322c0,-3.232 -1.651,-5.498 -4.766,-5.498c-2.714,0 -5.31,2.313 -5.31,6.065c0,3.822 2.501,6.064 5.687,6.064l0.024,-0.024Zm-3.092,-7.149c0.236,-1.841 1.416,-2.832 2.761,-2.832c1.581,-0 2.36,1.085 2.36,2.855l-5.121,-0.023Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.952,92.285l2.714,0l-0,-8.094c0.943,-0.943 1.604,-1.439 2.619,-1.439c1.251,0 1.793,0.708 1.793,2.596l0,6.914l2.714,-0l-0,-7.268c-0,-2.926 -1.086,-4.602 -3.563,-4.602c-1.581,0 -2.761,0.826 -3.799,1.817l-0.071,0l-0.189,-1.557l-2.218,-0l-0,11.633Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.52,92.568c1.463,0 2.855,-0.495 3.941,-1.227l-0.921,-1.675c-0.849,0.519 -1.699,0.826 -2.69,0.826c-1.864,-0 -3.185,-1.156 -3.398,-3.209l7.339,-0c0.047,-0.283 0.095,-0.803 0.095,-1.322c-0,-3.232 -1.653,-5.498 -4.767,-5.498c-2.714,0 -5.309,2.313 -5.309,6.065c-0,3.822 2.501,6.064 5.686,6.064l0.024,-0.024Zm-3.091,-7.149c0.236,-1.841 1.416,-2.832 2.761,-2.832c1.581,-0 2.359,1.085 2.359,2.855l-5.12,-0.023Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.858,82.87l1.557,0l-0,9.415l2.713,0l0,-9.415l2.266,0l-0,-2.147l-2.266,-0l0,-1.227c0,-1.345 0.496,-1.935 1.44,-1.935c0.378,-0 0.802,0.094 1.203,0.259l0.519,-2.029c-0.519,-0.189 -1.274,-0.377 -2.1,-0.377c-2.737,-0 -3.822,1.746 -3.822,4.129l-0,1.203l-1.558,0.095l0.048,2.029Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.09,92.285l2.714,0l-0,-11.586l-2.714,0l0,11.586Zm1.369,-13.615c0.944,-0 1.652,-0.637 1.652,-1.534c-0,-0.897 -0.708,-1.51 -1.652,-1.51c-0.944,-0 -1.652,0.613 -1.652,1.51c0,0.897 0.708,1.534 1.652,1.534Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.682,92.568c0.92,0 1.723,-0.212 2.336,-0.401l-0.448,-1.982c-0.331,0.118 -0.803,0.236 -1.18,0.236c-1.109,0 -1.628,-0.66 -1.628,-2.006l-0,-5.498l2.95,0l-0,-2.147l-2.95,-0l-0,-3.162l-2.242,0l-0.306,3.162l-1.794,0.118l-0,2.029l1.652,0l-0,5.522c-0,2.501 0.991,4.177 3.657,4.177l-0.047,-0.048Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.604,92.568c3.445,0 5.522,-2.076 5.522,-4.577c-0,-2.218 -1.275,-3.375 -3.092,-4.13l-2.076,-0.873c-1.275,-0.519 -2.431,-0.968 -2.431,-2.171c0,-1.109 0.944,-1.793 2.407,-1.793c1.322,-0 2.36,0.472 3.327,1.298l1.393,-1.723c-1.204,-1.203 -2.95,-1.935 -4.743,-1.935c-2.997,0 -5.168,1.888 -5.168,4.342c-0,2.242 1.581,3.445 3.091,4.059l2.1,0.897c1.392,0.589 2.384,0.99 2.384,2.241c-0,1.204 -0.944,1.982 -2.667,1.982c-1.416,0 -2.879,-0.708 -3.964,-1.746l-1.581,1.864c1.463,1.44 3.469,2.242 5.545,2.242l-0.047,0.023Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.214,92.568c2.879,0 5.498,-2.218 5.498,-6.04c0,-3.847 -2.619,-6.065 -5.498,-6.065c-2.879,0 -5.498,2.218 -5.498,6.065c-0,3.822 2.619,6.04 5.498,6.04Zm0,-2.218c-1.699,0 -2.714,-1.51 -2.714,-3.822c0,-2.313 1.015,-3.847 2.714,-3.847c1.699,0 2.714,1.534 2.714,3.847c-0,2.312 -1.015,3.822 -2.714,3.822Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.405,92.568c0.638,0 1.086,-0.094 1.416,-0.212l-0.33,-2.029c-0.189,0.047 -0.283,0.047 -0.401,0.047c-0.283,-0 -0.567,-0.236 -0.567,-0.897l0,-13.827l-2.713,-0l-0,13.686c-0,2.005 0.708,3.232 2.619,3.232l-0.024,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.631,92.568c1.581,0 2.69,-0.778 3.704,-1.982l0.071,0l0.189,1.7l2.218,-0l0,-11.587l-2.714,0l0,7.929c-0.873,1.133 -1.533,1.605 -2.548,1.605c-1.251,-0 -1.793,-0.708 -1.793,-2.596l-0,-6.914l-2.714,-0l0,7.268c0,2.926 1.085,4.601 3.563,4.601l0.024,-0.024Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.777,92.568c0.92,0 1.722,-0.212 2.336,-0.4l-0.449,-1.983c-0.33,0.118 -0.802,0.236 -1.18,0.236c-1.109,0 -1.628,-0.66 -1.628,-2.006l0,-5.498l2.95,0l0,-2.147l-2.95,-0l0,-3.162l-2.241,0l-0.307,3.162l-1.794,0.118l0,2.029l1.652,0l0,5.522c0,2.501 0.991,4.177 3.658,4.177l-0.047,-0.048Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.868,92.286l2.713,-0l0,-11.587l-2.713,0l0,11.587Zm1.369,-13.616c0.943,-0 1.651,-0.637 1.651,-1.534c0,-0.897 -0.708,-1.51 -1.651,-1.51c-0.945,0 -1.652,0.613 -1.652,1.51c-0,0.897 0.707,1.534 1.652,1.534Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.05,92.568c2.879,0 5.498,-2.217 5.498,-6.04c0,-3.847 -2.619,-6.065 -5.498,-6.065c-2.879,0 -5.498,2.218 -5.498,6.065c-0,3.823 2.619,6.04 5.498,6.04Zm0,-2.217c-1.699,-0 -2.714,-1.511 -2.714,-3.823c0,-2.313 1.015,-3.847 2.714,-3.847c1.699,0 2.713,1.534 2.713,3.847c0,2.312 -1.014,3.823 -2.713,3.823Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.622,92.286l2.714,-0l0,-8.094c0.944,-0.944 1.605,-1.44 2.619,-1.44c1.251,0 1.794,0.708 1.794,2.596l-0,6.914l2.714,-0l-0,-7.268c-0,-2.926 -1.086,-4.602 -3.564,-4.602c-1.581,0 -2.76,0.826 -3.799,1.817l-0.071,0l-0.189,-1.557l-2.218,-0l0,11.634Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.51,92.568c2.926,0 4.484,-1.604 4.484,-3.586c-0,-2.148 -1.746,-2.902 -3.304,-3.469c-1.25,-0.448 -2.407,-0.779 -2.407,-1.675c0,-0.708 0.543,-1.251 1.699,-1.251c0.897,-0 1.699,0.401 2.501,0.991l1.228,-1.652c-0.944,-0.731 -2.218,-1.368 -3.823,-1.368c-2.596,-0 -4.2,1.439 -4.2,3.445c-0,1.935 1.722,2.808 3.232,3.374c1.228,0.472 2.478,0.897 2.478,1.864c0,0.779 -0.59,1.369 -1.84,1.369c-1.157,-0 -2.148,-0.472 -3.163,-1.274l-1.25,1.722c1.132,0.921 2.785,1.581 4.365,1.581l0,-0.071Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M68.937,9.776l0,55.645l-15.74,0l-0,-21.701l-21.463,-0l-0,21.701l-15.74,0l-0,-55.645l15.74,-0l-0,20.906l21.463,0l-0,-20.906l15.74,-0Z",
    style: {
      fill: "#25347b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.863,24.323c-1.643,-1.431 -4.081,-2.147 -7.313,-2.147l-8.744,0l-0,16.297l8.744,-0c3.232,-0 5.67,-0.702 7.313,-2.106c1.642,-1.404 2.465,-3.405 2.465,-6.003c0,-2.595 -0.823,-4.61 -2.465,-6.041Zm-7.472,26.313l-8.585,-0l-0,14.785l-15.74,0l-0,-55.645l25.438,-0c5.034,-0 9.406,0.834 13.116,2.503c3.71,1.669 6.571,4.054 8.586,7.155c2.013,3.1 3.021,6.744 3.021,10.93c0,4.028 -0.942,7.54 -2.822,10.533c-1.882,2.995 -4.571,5.341 -8.068,7.035l12.003,17.489l-16.854,0l-10.095,-14.785Z",
    style: {
      fill: "#25347b",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.837,48.4c0,-3.796 -2.78,-5.695 -8.34,-5.695l-13.313,0l-0,11.39l13.313,-0c5.56,-0 8.34,-1.898 8.34,-5.695Zm-21.653,-27.51l-0,10.828l10.907,0c5.346,0 8.021,-1.817 8.021,-5.454c-0,-3.581 -2.675,-5.374 -8.021,-5.374l-10.907,0Zm34.967,20.652c1.818,2.38 2.727,5.253 2.727,8.622c0,4.92 -1.978,8.716 -5.935,11.388c-3.957,2.675 -9.678,4.011 -17.163,4.011l-30.316,0l-0,-56.141l28.713,-0c7.164,-0 12.617,1.323 16.36,3.971c3.742,2.646 5.614,6.215 5.614,10.706c0,2.674 -0.655,5.066 -1.965,7.178c-1.31,2.112 -3.167,3.783 -5.573,5.013c3.208,1.122 5.72,2.874 7.538,5.252Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.352,22.013l-17.243,-0l0,-12.591l50.286,-0l0,12.591l-17.163,-0l-0,43.55l-15.88,0l0,-43.55Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.734,9.422l15.88,-0l-0,43.549l26.787,-0l0,12.592l-42.667,0l0,-56.141Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.958,53.292l-0,12.271l-45.075,0l-0,-56.141l44.032,-0l-0,12.271l-28.312,-0l-0,9.463l24.942,0l-0,11.87l-24.942,-0l-0,10.266l29.355,-0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.345,24.099c-1.657,-1.444 -4.117,-2.165 -7.377,-2.165l-8.822,-0l-0,16.441l8.822,-0c3.26,-0 5.72,-0.708 7.377,-2.126c1.658,-1.416 2.488,-3.434 2.488,-6.055c0,-2.619 -0.83,-4.652 -2.488,-6.095Zm-7.539,26.546l-8.66,-0l-0,14.918l-15.881,0l-0,-56.141l25.663,-0c5.079,-0 9.492,0.842 13.236,2.527c3.74,1.684 6.629,4.09 8.661,7.218c2.031,3.127 3.047,6.804 3.047,11.027c-0,4.064 -0.949,7.607 -2.846,10.627c-1.898,3.021 -4.61,5.387 -8.142,7.098l12.11,17.644l-17.003,0l-10.185,-14.918Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.347,29.385l-0,10.673c-0,8.984 -3.529,13.475 -10.587,13.475c-7.111,0 -10.666,-4.491 -10.666,-13.475l-0,-10.433l-12.003,-12.002l-3.877,-0l-0,22.917c-0,8.341 2.312,14.785 6.938,19.329c4.624,4.544 11.107,6.817 19.449,6.817c8.341,-0 14.823,-2.273 19.448,-6.817c4.625,-4.544 6.937,-10.988 6.937,-19.329l0,-22.917l-3.877,-0l-11.762,11.762Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.342,31.796c0,1.501 -1.216,2.718 -2.717,2.718c-1.502,-0 -2.719,-1.217 -2.719,-2.718c0,-1.502 1.217,-2.719 2.719,-2.719c1.501,0 2.717,1.217 2.717,2.719Z",
    style: {
      fill: "#231f20",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.342,42.935c0,1.501 -1.216,2.718 -2.717,2.718c-1.502,-0 -2.719,-1.217 -2.719,-2.718c0,-1.502 1.217,-2.719 2.719,-2.719c1.501,0 2.717,1.217 2.717,2.719Z",
    style: {
      fill: "#231f20",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.625,40.216c-1.502,0 -2.719,1.217 -2.719,2.719c0,1.501 1.217,2.718 2.719,2.718c1.501,-0 2.717,-1.217 2.717,-2.718c0,-1.502 -1.216,-2.719 -2.717,-2.719Zm-0,-11.139c-1.502,0 -2.719,1.217 -2.719,2.719c0,1.501 1.217,2.718 2.719,2.718c1.501,-0 2.717,-1.217 2.717,-2.718c0,-1.502 -1.216,-2.719 -2.717,-2.719Zm12.162,-18.746l0,11.559c0,0.217 -0.107,0.419 -0.287,0.541c-0.11,0.074 -0.237,0.113 -0.366,0.113c-0.082,-0 -0.164,-0.016 -0.242,-0.048l-7.377,-2.945c-1.056,1.352 -2.661,2.145 -4.395,2.145c-1.593,-0 -3.118,-0.696 -4.172,-1.882l-6.719,2.682c-0.201,0.082 -0.429,0.056 -0.608,-0.065c-0.18,-0.122 -0.287,-0.324 -0.287,-0.541l-0,-11.559c-0,-0.217 0.107,-0.419 0.287,-0.541c0.179,-0.121 0.407,-0.146 0.608,-0.066l6.719,2.683c1.055,-1.186 2.579,-1.881 4.172,-1.881c1.734,-0 3.339,0.793 4.395,2.145l7.377,-2.947c0.201,-0.08 0.429,-0.055 0.608,0.066c0.18,0.122 0.287,0.324 0.287,0.541Z",
    style: {
      fill: "#25347b",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.994,
    y: 0.414,
    width: 480,
    height: 105,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrButlerLogoLarge);
export default __webpack_public_path__ + "static/media/hrButlerLogoLarge.ea874c5f00a615106fe9097ecad5a3e2.svg";
export { ForwardRef as ReactComponent };